"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EXTENDED_FORMAT = void 0;
exports.EXTENDED_FORMAT = 'MM/dd/yy - hh:mm a';
